import { render, staticRenderFns } from "./dataV7.vue?vue&type=template&id=7c94a822&scoped=true&"
import script from "./dataV7.vue?vue&type=script&lang=js&"
export * from "./dataV7.vue?vue&type=script&lang=js&"
import style0 from "./dataV7.vue?vue&type=style&index=0&id=7c94a822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c94a822",
  null
  
)

export default component.exports